import { fromCategories, toSearchParams } from '~features/crawler-filter';
import { DEFAULT_CATEGORY_SCHEME, categorizeCrawlersList } from '~features/crawler-filter';
import type { AiCrawlerLineup } from '../shared';

export type CdnAnalyticsDeepLinkParams = {
  url: string;
  dateFrom: string;
  dateTo: string;
  crawlers?: string[];
  domain?: string;
};

// CDN Analytics search condition for an exact-URL match (vs the default
// 'like'/contains), so the link opens scoped to the clicked page alone.
const EXACT_MATCH_CONDITION = 'eq';

// Discoverability stores granular crawler ids while CDN Analytics filters by
// provider category; an empty `crawlers` there means every crawler, AI or not.
function aiCrawlerCategories(lineup: AiCrawlerLineup, crawlerIds: string[] | undefined): string[] {
  const categories = categorizeCrawlersList(crawlerIds ?? [], DEFAULT_CATEGORY_SCHEME).filter((category) =>
    lineup.categories.includes(category)
  );
  return categories.length > 0 ? categories : [...lineup.categories];
}

// Links CDN Analytics to a single page, carrying the active date range, domain,
// and AI crawler filter. The page URL is sent as the `q` search term matched
// exactly, so CDN Analytics opens scoped to that page rather than every URL
// containing it.
export function buildCdnAnalyticsLink(lineup: AiCrawlerLineup, params: CdnAnalyticsDeepLinkParams): string {
  const search = new URLSearchParams();
  search.append('dateFrom', params.dateFrom);
  search.append('dateTo', params.dateTo);
  if (params.domain) search.append('domain', params.domain);
  const { crawlers } = toSearchParams(fromCategories(aiCrawlerCategories(lineup, params.crawlers), DEFAULT_CATEGORY_SCHEME));
  if (crawlers) search.append('crawlers', crawlers);
  search.append('q', params.url);
  search.append('q_condition', EXACT_MATCH_CONDITION);
  return `/cdn-analytics?${search.toString()}`;
}
